module.exports = __webpack_public_path__ + "img/7.4c030f08.png";